/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_Success_BodyInputs */

const cs_public_site_demand_success_body = /** @type {(inputs: Public_Site_Demand_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Děkujeme. Makléř se vám ozve co nejdříve.`)
};

const en_public_site_demand_success_body = /** @type {(inputs: Public_Site_Demand_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you. An agent will get back to you soon.`)
};

/**
* | output |
* | --- |
* | "Thank you. An agent will get back to you soon." |
*
* @param {Public_Site_Demand_Success_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_success_body = /** @type {((inputs?: Public_Site_Demand_Success_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_Success_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_success_body(inputs)
	return cs_public_site_demand_success_body(inputs)
});